/**
 * example:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645476022976,
	"notificationDetails": {"updateType":"SETUP_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"RELATED_TRADING_SYSTEMS","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candleDuration":1,"timeUnit":"MINUTES","periodLength":3},"triggerPrice":102.3,"tradeDirection":"LONG","tacticName":"BREAK_EMA","symbol":"XYZ"},
	"date": "2022-02-21T15:40:23.543-0500",
	"timestamp": "1645476023549"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) periodLength
 * 3) timeUnit
 */
export function breakEmaParser(pluginTemplate) {
    const parsedObject = {
        candleDuration: null,
        periodLength: null,
        timeUnit: null,
    }
    if(pluginTemplate) {
        parsedObject.candleDuration=pluginTemplate.candleDuration;
        parsedObject.periodLength=pluginTemplate.periodLength;
        parsedObject.timeUnit=pluginTemplate.timeUnit;
    }
    return parsedObject;
}